import React from 'react';
import { 
  Newspaper, 
  Flag, 
  FileText, 
  AlertTriangle, 
  RefreshCw,
  ArrowRight,
  TrendingUp
} from 'lucide-react';
import './Modulos.css';

const Modulos = ({ onModuleSelect }) => {
  const modulos = [
    {
      id: 'monitoreo-medios',
      nombre: 'Monitoreo',
      sigla: 'MM',
      descripcion: 'Identificación temprana de señales públicas en medios y redes sociales',
      icono: Newspaper,
      color: '#2196F3',
      ruta: 'monitoreo-medios'
    },
    {
      id: 'adquisiciones-publicas',
      nombre: 'Adquisiciones públicas',
      sigla: 'AP',
      descripcion: 'Análisis preventivo de contratación pública para detectar banderas rojas y patrones de riesgo',
      icono: Flag,
      color: '#F44336',
      ruta: 'banderas-rojas'
    },
    {
      id: 'requerimientos-ia',
      nombre: 'Contratación Personal',
      sigla: 'CDP',
      descripcion: 'Análisis de posibles irregularidades en procesos de contratación de personal',
      icono: FileText,
      color: '#4CAF50',
      ruta: 'requerimientos-probidad'
    },
    {
      id: 'direccion-ejecutiva',
      nombre: 'Dirección Ejecutiva',
      sigla: 'DE',
      descripcion: 'Gestión y seguimiento de información estratégica remitida por la Dirección Ejecutiva sobre posibles riesgos o temas prioritarios',
      icono: AlertTriangle,
      color: '#FF9800',
      ruta: 'gestion-informacion'
    },
    {
      id: 'casos-previos',
      nombre: 'Casos previos',
      sigla: 'CP',
      descripcion: 'Seguimiento de información asignado previamente en la Dirección',
      icono: RefreshCw,
      color: '#9C27B0',
      ruta: 'seguimiento'
    }
  ];

  return (
    <div className="modulos-container">
      <div className="modulos-header">
        <h1 className="modulos-title">
          <TrendingUp size={32} />
          Módulos del Sistema
        </h1>
        <p className="modulos-subtitle">
          Plataforma integral de gestión de alertas y casos institucionales
        </p>
      </div>

      <div className="modulos-grid">
        {modulos.map((modulo) => {
          const IconComponent = modulo.icono;
          return (
            <div
              key={modulo.id}
              className="modulo-card"
              onClick={() => onModuleSelect(modulo.ruta)}
              style={{ '--modulo-color': modulo.color }}
            >
              <div className="modulo-header">
                <div className="modulo-icon" style={{ backgroundColor: modulo.color }}>
                  <IconComponent size={32} />
                </div>
                <div className="modulo-sigla" style={{ color: modulo.color }}>
                  {modulo.sigla}
                </div>
              </div>

              <div className="modulo-content">
                <h3 className="modulo-nombre">{modulo.nombre}</h3>
                <p className="modulo-descripcion">{modulo.descripcion}</p>
              </div>

              <div className="modulo-footer">
                <button className="modulo-btn" style={{ color: modulo.color }}>
                  Acceder al módulo
                  <ArrowRight size={16} />
                </button>
              </div>
            </div>
          );
        })}
      </div>

      <div className="modulos-info">
        <div className="info-card">
          <h3>Sistema ALERTA 360</h3>
          <p>
            Plataforma institucional de la Comisión Nacional contra la Corrupción (CNC) 
            destinada a detectar, gestionar, analizar y dar seguimiento a señales tempranas 
            de posibles irregularidades administrativas o hechos vinculados a corrupción.
          </p>
        </div>

        <div className="info-card">
          <h3>Características principales</h3>
          <ul>
            <li>📋 Nomenclatura única por módulo (MM-001, BR-001, etc.)</li>
            <li>🔍 Filtros avanzados de búsqueda</li>
            <li>📊 Tableros analíticos personalizados</li>
            <li>📄 Exportación a Excel y PDF</li>
            <li>🔒 Bitácora automática completa</li>
            <li>👥 Asignación a Instancias de Probidad</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Modulos;